'use client';

import { motion } from 'framer-motion';
import TreeOfLife from '../ui/TreeOfLife';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[calc(100dvh-4.25rem)] bg-forest-dark flex items-center justify-center overflow-hidden"
    >
      {/* Tree of life — canopy here, roots continue in the Services section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.6, ease: [0.25, 0.1, 0.25, 1] }}
        className="absolute inset-0"
      >
        <TreeOfLife part="top" className="bg-forest-lightest/15" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-sans text-cream-200/65 tracking-[0.3em] uppercase text-xs mb-7"
        >
          Bien-être &nbsp;&bull;&nbsp; Sérénité &nbsp;&bull;&nbsp; Harmonie
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
          className="font-serif text-cream-100 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-[1.1] mb-6"
        >
          La Canopée
          <br />
          <em className="font-light">de Christelle</em>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="font-sans text-cream-100/65 text-lg md:text-xl leading-relaxed mb-10 max-w-lg mx-auto"
        >
          Un espace dédié à votre bien-être, où chaque soin est une invitation
          au lâcher-prise.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.1 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            href="#booking"
            className="bg-cream-100 text-forest-dark font-sans px-8 py-3.5 rounded-full hover:bg-cream-50 transition-colors tracking-wide text-sm"
          >
            Réserver une séance
          </a>
          <a
            href="#services"
            className="border border-cream-100/40 text-cream-100 font-sans px-8 py-3.5 rounded-full hover:bg-cream-100/10 transition-colors tracking-wide text-sm"
          >
            Découvrir mes soins
          </a>
        </motion.div>
      </div>

    </section>
  );
}
